import { startSetCurrentRestaurant } from "actions/userFunctions"
import { Button } from "components/LEGACY/styled-components/Buttons"
import { CheckboxCircle, ChevronRightCircle } from "components/LEGACY/styled-components/Icons"
import { Td, Tr } from "components/LEGACY/styled-components/Table"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { useUser } from "hooks/firestore/simple/useUser"
import { useRouter } from "next/router"
import { useState } from "react"
import Shop from "types/firestore/shop"
import Loader from "../utils/Loader"

const RestaurantTableItem = ({ shop, index }: { shop: WithRef<Shop>; index: number }) => {
  const router = useRouter()
  const [isLoading] = useState(false)
  const user = useUser()

  const linkTo = () => {
    startSetCurrentRestaurant(shop._ref.id)
    router.push(`/admin/dashboard`)
  }
  const thisShopIsActive = user?.currentRestaurant === shop._ref.id

  if (isLoading) {
    return <Loader />
  } else {
    return (
      <Tr>
        <Td width="20px">{index + 1}</Td>
        <Td width="50%">{shop.name}</Td>
        <Td>{shop.contact?.city || ""}</Td>
        <Td>
          {thisShopIsActive ? (
            <Button disabled ghost style={{ borderColor: "transparent" }}>
              <CheckboxCircle primary size="16" />
              <span style={{ marginLeft: "0.5rem", fontSize: "1rem", fontWeight: "bold" }}> Aktiver&nbsp;Betrieb</span>
            </Button>
          ) : (
            <Button ghost onClick={linkTo}>
              <ChevronRightCircle color="currentColor" size="16" />
              <span style={{ marginLeft: "0.5rem", fontSize: "1rem", fontWeight: "bold" }}> Betrieb&nbsp;wechseln</span>
            </Button>
          )}
        </Td>
      </Tr>
    )
  }
}

export default RestaurantTableItem
